
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/getting-started/templates",
      function () {
        return require("private-next-pages/material-ui/getting-started/templates.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/getting-started/templates"])
      });
    }
  